import React from "react";

export default function FooterCard16() {
  return (<>
    <footer className="fs-footer">
      <div className="fs-right-blob"></div>
 <div className="fs-right-blob-2"></div>

      <div className="fs-container">

        <div className="fs-col logo-col">
          <h2 className="fs-logo">F S</h2>
          <p className="fs-subtitle">Fashion Stylist</p>

          <p className="fs-text">
            Te obtenu ut adepto satis somno. Aliisque institoribus iter 
            deliciae vivet vita. Nam exempli gratia, quotiens ego vadam 
            ad diversorum.
          </p>

          <p className="fs-error">Error: Contact form not found.</p>
        </div>

        <div className="fs-col">
          <h3 className="fs-title">Explore</h3>
          <ul>
            <li>About</li>
            <li>Our Team</li>
            <li>Locations</li>
            <li>Gallery</li>
            <li>Blog</li>
          </ul>
        </div>

        <div className="fs-col">
          <h3 className="fs-title">Services</h3>
          <ul>
            <li>Makeover</li>
            <li>Specialists</li>
            <li>Makeover For Men</li>
            <li>Makeover For Women</li>
            <li>Book an Appointment</li>
          </ul>
        </div>

        <div className="fs-col">
          <h3 className="fs-title">Have Any Queries?</h3>

          <p className="fs-small-title">Get a Quote</p>
          <p className="fs-phone">+123 456 7890</p>

          <p className="fs-small-title">Or Mail Us On</p>
          <p className="fs-mail">info@nyk.com</p>

          <button className="fs-buy-btn">Buy Now</button>
        </div>

      </div>

      <div className="fs-bottom">
        Stylist WordPress Theme 2020 Designed & Developed by VW Themes
      </div>
    </footer>
    <style>{`.fs-footer {
  position: relative;margin-top:50px;
  background: #1f242b;
  color: #ddd;
  padding: 80px 0 40px;
  overflow: hidden;
  font-family: 'Poppins', sans-serif;
}

/* Peach curve right side */
.fs-right-blob {
  position: absolute;
  right: -250px;
  top: 0;
  width: 350px;
  height: 350px;
  border:70px solid rgba(144, 202, 249,0.41);
  border-radius: 50%;
  opacity: 0.9;
  z-index: 1;
}/* Peach curve left side */
.fs-right-blob-2 {
  position: absolute;
  left: -150px;
  top: -100px;
  width: 250px;
  height: 250px;
  border:40px solid #111111;
  border-radius: 50%;
  opacity: 0.9;
  z-index: 1;
}

/* Main container */
.fs-container {
  position: relative;
  z-index: 5;
  width: 90%;
  max-width: 1300px;
  margin: auto;
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1fr;
  gap: 40px;
}

/* LOGO area */
.fs-logo {
  font-size: 60px;
  font-weight: 900;
  color: rgba(144, 202, 249,1);
  margin: 0;
}

.fs-subtitle {
  font-size: 22px;
  color: #ffffff;
  margin-bottom: 20px;
}

.fs-text {
  color: #bbbbbb;
  line-height: 1.6;
  max-width: 330px;
}

.fs-error {
  margin-top: 10px;
  color: rgba(144, 202, 249,1);
  font-size: 14px;
}

/* Titles */
.fs-title {
  font-size: 20px;
  margin-bottom: 18px;
  color: #ffffff;
}

/* Links */
.fs-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.fs-col li {
  margin: 8px 0;
  cursor: pointer;
  transition: 0.2s;
}

.fs-col li:hover {
  color: rgba(144, 202, 249,1);
  letter-spacing: 1px;
}

/* Contact Column */
.fs-small-title {
  color: #ffffff;
  margin-top: 10px;
  font-weight: 600;
}

.fs-phone, .fs-mail {
  margin: 5px 0 15px;
}

/* Buy Button */
.fs-buy-btn {
  background: rgba(144, 202, 249,1);
  color: #1f1f1f;
  padding: 10px 22px;
  border-radius: 20px;
  border: none;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
}

.fs-buy-btn:hover {
  background: #ffba9a;
}

/* Bottom bar */
.fs-bottom {
  margin-top: 60px;
  padding-top: 30px;
  text-align: center;
  font-size: 14px;
  color: #9ea4a8;
  border-top: 1px solid #333;
}

/* Responsive */
@media (max-width: 900px) {
  .fs-container {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 600px) {
  .fs-container {
    grid-template-columns: 1fr;
    text-align: center;
  }
}
`}</style>
  </>);
}
